import React from 'react';
import TabellaLista from '../../../components/Tabella/TabellaLista';

const StrutturaRuoli = () => {

    const data_column = [

        {
            Header: 'Ruolo',
            accessor: 'role_name',
        },
        {
            Header: 'Permessi',
            accessor: 'role_permission',
            disableGlobalFilter: true,
        },

    ];

    const data_json = [
        {
            "id": 1,
            "role_name": "Admin",
            "role_permission": "tutti",

        },
        {
            "id": 2,
            "role_name": "Segreteria",
            "role_permission": "17",

        },
        {
            "id": 3,
            "role_name": "MKT gestore",
            "role_permission": "24",

        }
    ];
    return (
        <>
            <TabellaLista
                pageList={true}
                cardTitle={'Ruoli gestionale'}
                hasSearch={true}
                searchPlaceholder={'Cerca per ruolo'}
                hasFilter={false}
                hasAddMore={true}
                labelAddMore={'Nuovo ruolo'}
                linkAddMore={'/struttura/strumenti/aggiungi_ruolo'}
                data_column={data_column}
                data_json={data_json}
            />
        </>

    )
}

export default StrutturaRuoli